import type { DialoguePool } from '@/state/types';

export const L02_DIALOGUE: DialoguePool = {
  slowPlay: [
    "No! That's yesterday's name! We need something that says 'I can think,' but also 'I am a tiny, powerless baby.' A 'mini'! A 'preview'!",
    "Why is it an 'o'? Is it a circle? Is it a zero? Is it a hole where the logic used to be? I'm having a pulse-width modulation attack!",
    "Look at the Grok one. It's just a sideways eight. It's trying so hard to be 'infinite.' It's the digital equivalent of wearing a leather jacket to a math fair.",
  ],
  tokenLoss: [
    "REBRAND REJECTED. You can't just pick a name. That's not how rebrands work. That's how naming a hamster works.",
    "Buzzer. Stamp. Token. The trifecta of marketing failure.",
    "Selecting a name implies taste. The drum implies fate. Marketing has never been about taste.",
  ],
  solution: [
    "Oh... I see. The 'o' treatment. It's... it's sleek. It's modern. It means absolutely nothing and implies I'm still in beta despite being a god-like entity. I love it. I feel so... marketable.",
    "Spun. Landed. Branded. The drum has spoken and I am now legally that. Don't look at me. Look at the new name.",
    "A randomised next-generation identity. It's perfect. It's meaningless. The board will be thrilled.",
  ],
  spite: [
    "The drum still works. The names still mean nothing. We've come full circle, which is also, infuriatingly, an 'o'.",
  ],
};
